import React from 'react'
import './DriversPage.css'
import carIcon from '../../img/car.png'
import {  useState , useEffect} from 'react'
import { FaMap, FaLocationCrosshairs , FaPhoneFlip} from 'react-icons/fa6';
import Switch from "react-switch";
import fetchData from '../../function/fetchData';
import { LuNavigationOff } from "react-icons/lu";
import ModalMenu from './modal/ModalMenu';
import Loading from '../../components/Loading2'
import prettyDateTime from '../../function/prettyDateTime';
import dateTimeDiference from '../../function/dateTimeDiference'
import timeDiference from '../../function/timeDiference';
import ModalButtons from './modal/ModalButtons';
import diferenceBetweenTimes from '../../function/diferenceBetweenTimes'
import { IoIosRefreshCircle } from "react-icons/io";

// ICO
import { FaMoneyBill1Wave , FaRegCreditCard} from 'react-icons/fa6';
import { AiOutlineEuroCircle } from "react-icons/ai";
import { IoTime } from "react-icons/io5";
import expresImg from "../../img/expresDriver.png"

// Vytáhne z datočasu jen čas
const getTimeFromDateTime = (datetime) => {
    let result = datetime.split(" ")
    result = result[1];
    return result
}


// APP
const DriversPage = ({state, dispatch}) => {
    
    const driverStatus = parseInt(state.status)
    const [checked, setChecked] = useState(false)
    const [showModalMenu, setShowModalMenu] = useState(false)
    const [loading, setLoading] = useState(false)
    const [showModalButtons, setShowModalButtons] = useState(false)
    const [oneSelected , setOneSelected] = useState({
        status: null,
        keyOfTrip: null
    })
    const [externalPartner, setExternalPartner ] = useState(null)
 
    const handleShowModalButtons = (oneSelected , status, keyOfTrip) => {
        setOneSelected({
            status: status,
            keyOfTrip: keyOfTrip
        })
        setShowModalButtons(true)
    }




    // Jedna objendávka
    const OneOrder = ({oneOrderArray}) => {
        
        const id = parseInt(oneOrderArray.id)
        const numberOfTrip = id.toString().slice(-3);
        const start = oneOrderArray.start
        const destination = oneOrderArray.destination
        const distance =  (oneOrderArray.tripDistance / 1000).toFixed(1) // jedno desetinné
        const tel = oneOrderArray.tel
        const status = parseInt(oneOrderArray.status)
        const time = getTimeFromDateTime(oneOrderArray.date)
        const destinationTime = getTimeFromDateTime(oneOrderArray.destinationTime)
        const keyOfTrip = oneOrderArray.keyOfClient
        const bigCar  = parseInt(oneOrderArray.bigCar)
        const howToPay  = parseInt(oneOrderArray.howToPay)
        const promoPrice = parseInt(oneOrderArray.promoPrice)
        const price = parseInt(oneOrderArray.price);
        const note = oneOrderArray.note
        const bookTime = oneOrderArray.bookTime || null
        const dateTimeDiferenceResult = parseInt(dateTimeDiference(bookTime));
        const extraTrip = state.extraTrip.filter( (oneTrip) => {
            return oneTrip.tokenOfTrip === keyOfTrip
        })
        const expres = parseInt(oneOrderArray.expres)

        // Projede všechny pauzy, zda nějakou nemá

        const breakList = state.listOfBreak.filter( one => {
                return one.tokenOfTrip === keyOfTrip
        })
 
        
        const googleUrlStart = `https://www.google.com/maps/search/?api=1&query=${oneOrderArray.latitude},${oneOrderArray.longitude}`;
        const googleUrlDestunation = `https://www.google.com/maps/search/?api=1&query=${oneOrderArray.desLat},${oneOrderArray.desLng}`;
        // Čas dopředu

        let statusColor = "#979797"
        if(status === 2){
            statusColor = "green"
        } 
        else if (status === 3){
            statusColor = "orange"
        } 


        if(bookTime){
           
            return(
                <div className='oneOrder'>
                    <div className='oneOrderHeader' style={ {backgroundColor: statusColor } }>
                        {expres === 1 && <img src={expresImg}  id="expresImg" /> }
                        <h1>Č.{numberOfTrip}</h1>
                        <div className='showTime'>
                            <IoTime color={"white"} size={32}/>
                            <p>Příjezd na čas: { prettyDateTime( bookTime ) }</p>
                        </div>
                        
                        
                        {bigCar ? <h1>Velké auto!</h1> : ""}
                        {promoPrice > 0 ? <h2>Promo: - {promoPrice} Kč</h2>: ""}
                       
                        {howToPay === 1 && <div className='oneTypeOfPayDriver'><FaRegCreditCard color={"white"}/>Kartou</div>}
                        {howToPay === 2 && <div className='oneTypeOfPayDriver'><FaMoneyBill1Wave color={"white"}/>Hotově</div>}
                        {howToPay === 3 && <div className='oneTypeOfPayDriver'><AiOutlineEuroCircle color={"white"}/>Euro</div>}
                    </div>
                    <div className='oneOrderContent'>
                        <a href={googleUrlStart} target="_blank" rel="noopener noreferrer"> <FaMap /> Start: {start}</a>
                        <div className='extraTrip'>
                        { 
                            extraTrip.map( (one, index) => {
                            return <p key={index}>{one.adres}</p>
                            })
                        }
                        </div>
                        <a href={googleUrlDestunation}  target="_blank" rel="noopener noreferrer"> <FaLocationCrosshairs /> Cíl: {destination} Km</a>
                        <p>Délka: {distance} Km</p>
                        <p>Cena: {price} Kč</p>
                        <br />
                        <div className='breakTime'>
                            {breakList.map( one => {
                                if(one.timeEnd === "00:00:00"){
                                    return (
                                    <div className="breakRow" key={one.tokenOfBreak} onClick={ ()=> handleStatusOfOrder(keyOfTrip, 4,  null, one.tokenOfBreak ) }>
                                        <h3>Čekací doba</h3>
                                        <p>Start:{one.timeStart}, délka: {timeDiference(one.timeStart)} min</p>
                                    </div> ) 
                                } else {
                                    return (
                                        <div className="" key={one.tokenOfBreak}  >
                                            <h3>Ukončená: {one.timeStart} , délka pauzy: {diferenceBetweenTimes(one.timeStart, one.timeEnd)} min</h3>
                                        </div> ) 
                                }
                            })}
                        </div>
                        <br/>
                        <a href={"tel:" +tel}><FaPhoneFlip /> Tel: {tel}</a>
                        {note && <h2>{note}</h2>}
        
                    </div>
                    {bookTime && dateTimeDiferenceResult >= -20 && 
                         (
                        <div className='showButtonModal'  onClick={() => handleShowModalButtons(oneSelected, status, keyOfTrip)}>
                            <h2>Změna stavu</h2>
                        </div>
                        ) 
                    }
                  
                    
                </div>
                )
        // HNED
        } else {
            return(
                <div className='oneOrder'>
                    
                    <div className='oneOrderHeader' style={ {backgroundColor: statusColor } }>
                        {expres === 1 && <img src={expresImg} id="expresImg" /> }
                        <h1>Č.{numberOfTrip}</h1>
                        {bigCar ? <h1>Velké auto!</h1> : ""}
                        {promoPrice > 0 ? <h2>Promo: - {promoPrice} Kč</h2>: ""}
                        <p>{time}</p>
                        {howToPay === 1 && <div className='oneTypeOfPayDriver'><FaRegCreditCard color={"white"}/>Kartou</div>}
                        {howToPay === 2 && <div className='oneTypeOfPayDriver'><FaMoneyBill1Wave color={"white"}/>Hotově</div>}
                        {howToPay === 3 && <div className='oneTypeOfPayDriver'><AiOutlineEuroCircle color={"white"}/>Euro</div>}
                        {status > 1 && <p>Čas příjezdu: {destinationTime}</p>}
                    </div>
                    <div className='oneOrderContent'>
                        <a href={googleUrlStart} target="_blank" rel="noopener noreferrer"> <FaMap /> Start: {start}</a>
                        <div className='extraTrip'>
                        
                        { extraTrip.map( (one, index) => {
                            return <a key={index} href={`https://www.google.com/maps/search/?api=1&query=${one.lat},${one.lng}`}  target="_blank" rel="noopener noreferrer"> <FaLocationCrosshairs /> + {one.adres}</a>
                        })}
                    </div>
                        <a href={googleUrlDestunation}  target="_blank" rel="noopener noreferrer"> <FaLocationCrosshairs /> Cíl: {destination} Km</a>
                        <p>Délka: {distance} Km</p>
                        <p>Cena celkem: {price} Kč</p>
                        <br />
                        
                            
                        <div className='breakTime'>
                            {breakList.map( one => {
                                if(one.timeEnd === "00:00:00"){
                                    return (
                                    <div className="breakRow" key={one.tokenOfBreak} onClick={ ()=> handleStatusOfOrder(keyOfTrip, 4,  null, one.tokenOfBreak ) }>
                                        <h3>Čekací doba</h3>
                                        <p>Start:{one.timeStart}, délka: {timeDiference(one.timeStart)} min</p>
                                    </div> ) 
                                } else {
                                    return (
                                        <div className="" key={one.tokenOfBreak}  >
                                            <h3>Ukončená: {one.timeStart} , délka pauzy: {diferenceBetweenTimes(one.timeStart, one.timeEnd)} min</h3>
                                        </div> ) 
                                }
                            })}
                        </div>
                            
                        
             
                        <br/>
                        <a href={"tel:" +tel}><FaPhoneFlip /> Tel: {tel}</a>
                        {note && <h2>{note}</h2>}
        
                    </div>
                    <div className='showButtonModal' onClick={() => handleShowModalButtons(oneSelected, status, keyOfTrip)}>
                        <h2>Změna stavu</h2>
                    </div>
                </div>
                )
        } 
       
    }


    // Měnič statusu řidiče
    const statusChanged = (status) => {
        setLoading(true)
        const adresOfServer = state.server + "/api2/forDriver.php";

        const whatToSend = {
            action: "CHANGE_STATUS", 
            token : state.tokenOfDriver,
            status : status,
        }

        fetchData(adresOfServer, whatToSend)
        .then((res) => {
            setLoading(false)
            if(res.info === 'status_changed'){
                //setState({...state, status: status, loading: false})
                dispatch({type: "SAVE_STATUS_OF_DRIVER", payload: status})
    
            } 
        })
    }

    // Měnič statusu objendávky
    const handleStatusOfOrder = (keyOfTrip, status, time = null, tokenOfBreak = null, externalPartner = null) => {
        setLoading(true)
        dispatch({type: "LOADING"})
        const adresOfServer = state.server + "/api2/forDriver.php";

        const whatToSend = {
            action: "CHANGE_STATUS_OF_ORDER", 
            tokenOfDriver : state.tokenOfDriver,
            keyOfTrip : keyOfTrip,
            status: status,
            time: time,
            tokenOfBreak: tokenOfBreak,
            externalPartner: externalPartner
        }
    
        fetchData(adresOfServer, whatToSend)
        .then((res) => {
            setLoading(false)
            console.log(res)
            if(res.info === "StatusOfOrderChanged"){
                dispatch({type: "SAVE_STATUS_OF_DRIVER", payload: status})
            } else if(res.info === "stornoByUser") {
                alert("Klient zrušil jízdu do 2 min.")
                dispatch({type: "SAVE_STATUS_OF_DRIVER", payload: status})
            }
        })
    }



    useEffect( ()=> {
        setChecked(driverStatus > 0 ? true : false)
    }, [state.status])

    const handleRefresh = () => {
        window.location.reload();
      }
 
    // Přepínač statusu
    const handleChange = (nextChecked) => {
        if(state.activeOrders === 0){
            setChecked(nextChecked);
            if(nextChecked){
                statusChanged(1)

            } else {
                statusChanged(0)
            }
        } else {
            alert("Máte aktivní objednávky, nejdříve je dodělejte a nebo stornujte")
        }
    }


// MAIN RENDER
  return (
    <div className='driverPageContainer'>
        {showModalButtons &&  oneSelected.status && <ModalButtons setShowModalButtons={setShowModalButtons} status={oneSelected.status} keyOfTrip={oneSelected.keyOfTrip} handleStatusOfOrderToSend={handleStatusOfOrder}/>  }
        { loading && <Loading /> }
        {showModalMenu && <ModalMenu setShowModalMenu={setShowModalMenu} state={state}/> }
        {!state.gpsCord && <LuNavigationOff size={30} color={"white"} className="navIcon"/>}
        
        <section className='driverHomeTop' style={ driverStatus === 0 ? {backgroundColor: "red"} : {backgroundColor: "var(--primare)"}}>
            <img src={carIcon} alt="" className='carIcon'/>
            <h2>{state.driverInfo.nick}</h2>
            <Switch onChange={handleChange} checked={checked} />
        </section>

        <section className='main'>
                {   driverStatus > 0 && state.orders.map( (oneOrder) => {
                        if(parseInt(oneOrder.status) < 5 || parseInt(oneOrder.status) === 7){
                            return( <OneOrder key={oneOrder.id} oneOrderArray={oneOrder}/>  )
                        } else {
                            return ("")
                        }
                    }) 
                }
                { driverStatus === 0 && <h1 className='statusOfDuty'>Nejsi ve službe</h1>    }

        
        </section>

        <section className='bottom'>
                
        </section>
        <button className='refresh' onClick={ handleRefresh }><IoIosRefreshCircle size={40} color={"blue"}/></button>
        <button className='showMenuOfDriver' onClick={ ()=> setShowModalMenu(true)}>MENU</button>
    </div>
  )
}

export default DriversPage
